import React, { useCallback, useContext, useEffect, useState } from "react";
import { Layout, Space, Typography } from "antd";
import { PageLockLogo } from "../../Assets/Index";
import { UserContext } from "../../Context/UserContext";

const { Content } = Layout;
const { Title, Text } = Typography;

export function PageAccessPermission({ children, access }) {
  const { userProfileData } = useContext(UserContext);
  const [isPermission, setIsPermission] = useState(false);
  useEffect(() => {
    const organization = userProfileData.currentOrganization;
    if (access.length == 0) return setIsPermission(true);
    if (organization?.role == "administrator") return setIsPermission(true);
    const hasPermission = access.some((permission) =>
      organization?.permission.some((orgPermission) => orgPermission?.name === permission)
    );
    if (hasPermission) {
      setIsPermission(true);
    } else {
      setIsPermission(false);
    }
  }, [access, userProfileData]);
  if (isPermission) {
    return <>{children}</>;
  }
  return (
    <Layout>
      <Content style={{ padding: "24px", minHeight: "calc(100vh - 64px)" }}>
        <Space
          direction="vertical"
          size="large"
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            minHeight: "400px",
          }}
        >
          <div className="lock-logo">
            <img width={350} height={350} src={PageLockLogo} alt="Access Denied" />
          </div>
          <Title level={1} style={{ margin: 0, fontWeight: "normal" }}>
            You don't have access
          </Title>
          <Text type="secondary" style={{ fontSize: "16px" }}>
            Access to this page is restricted, and you do not have the required permissions to view its content.
          </Text>
        </Space>
      </Content>
    </Layout>
  );
}

export function AccessPermission({ children, access }) {
  const { userProfileData } = useContext(UserContext);
  const [isPermission, setIsPermission] = useState(false);
  const organization = userProfileData?.currentOrganization;
  useEffect(() => {
    const hasPermission = access.some((permission) =>
      organization?.permission.some((orgPermission) => orgPermission?.name === permission)
    );
    if (hasPermission || organization.role == "administrator") {
      setIsPermission(true);
    }
  }, [access, organization, userProfileData]);
  if (isPermission) {
    return <>{children}</>;
  }
  return <></>;
}
